<template>
  <span class="badge" :class="`badge--${tone}`" :data-tone="tone">
    <small class="alignCentre nomargintopbottom"> {{ message }}</small>
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "Badge",
  props: {
    message: {
      type: String,
      default: "badge text",
    },
    tone: {
      type: String,
      default: "neutral",
      validator: (value) =>
        ["neutral", "success", "warning", "danger", "token"].includes(value),
    },
  },
};
</script>

<style scoped>
.badge {
  background: var(--color-surface-muted);
  color: var(--color-text-primary);
}

.badge--success {
  background: var(--color-feedback-success-surface);
  border-color: var(--color-feedback-success-border-emphasis);
}

.badge--warning {
  background: var(--color-feedback-warning-surface);
  border-color: var(--color-feedback-warning-border);
}

.badge--danger {
  background: var(--color-feedback-danger-surface-emphasis);
  border-color: var(--color-feedback-danger-border);
}

.badge--token {
  background: var(--color-token-standard-surface);
}

/* SMALL SCREENS */
@media only screen and (max-width: 490px) {
}
</style>
